import React, { useState } from 'react';
import LogoSvg from 'assets/logo.svg';
import { Link } from 'react-router-dom';
import { JoinWaitList } from 'features/misc';

export const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="relative z-10 w-full px-4 sm:px-8 lg:px-24 py-4 flex items-center justify-between bg-white mb-4">
      {/* Left Section */}
      <div className="flex items-center space-x-6">
        <Link to="/">
          <img src={LogoSvg} alt="Wire24 Logo" className="h-8 md:h-12" />
        </Link>
        <Link to="/company" className="text-gray-700 hover:text-gray-900 transition text-lg">
          Company
        </Link>
        <Link to="/contact" className="text-gray-700 hover:text-gray-900 transition text-lg">
          Contact Us
        </Link>
      </div>

      {/* Right Section */}
      <div className="hidden sm:flex space-x-6 items-center">
        <JoinWaitList />
      </div>

      {/* Mobile Menu Toggle */}
      <div className="sm:hidden flex items-center">
        <button
          className="text-gray-700 hover:text-gray-900 focus:outline-none focus:ring"
          aria-label="Toggle Menu"
          type="button"
          onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="absolute top-0 left-0 w-full bg-white shadow-md py-4 px-6 sm:hidden">
          <div className="flex flex-row items-end justify-end">
            <button className="" type="button" onClick={() => setMobileMenuOpen(false)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div className="flex flex-col items-center space-y-2">
            <JoinWaitList />
          </div>
        </div>
      )}
    </nav>
  );
};
